(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@mcafee/analytics-sdk-web", [], factory);
	else if(typeof exports === 'object')
		exports["@mcafee/analytics-sdk-web"] = factory();
	else
		root["@mcafee/analytics-sdk-web"] = factory();
})(window, function() {
return 